import { createSlice } from '@reduxjs/toolkit';

interface State {
    soundVolume: number,
    showGameAnimation: boolean,
    maxBetAllow: boolean,
    gameHotKeyEnabled: boolean,
    showGameInfo: boolean,
    showHotkeyPanel: boolean,
}

const initialState: State = {
    soundVolume: 1,
    showGameAnimation: true,
    maxBetAllow: true,
    gameHotKeyEnabled: true,
    showGameInfo: false,
    showHotkeyPanel: false,
};

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {
        setSoundVolume(state, action) {
            state.soundVolume = action.payload;
        },
        setGameAnimation(state, action) {
            state.showGameAnimation = action.payload;
        },
        setMaxBetAllow(state, action) {
            state.maxBetAllow = action.payload;
        },
        setGameHotKeyEnable(state, action) {
            state.gameHotKeyEnabled = action.payload;
        },
        visibleGameInfo(state, action) {
            state.showGameInfo = action.payload;
        },
        visibleHotKeyPanel(state, action) {
            state.showHotkeyPanel = action.payload;
        },
    },
});

// Export actions generated by createSlice  
export const {
    setSoundVolume,
    setGameAnimation,
    setMaxBetAllow,
    setGameHotKeyEnable,
    visibleGameInfo,
    visibleHotKeyPanel
} = settingSlice.actions;

// Export the reducer to be used in the store  
export default settingSlice.reducer;  